const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhysiotherapist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "1 1 18 17",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 14.081,
    y1: 14.061,
    x2: 14.81,
    y2: 14.07
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M15.229,11.363 c-0.551,0.018-1.024,0.253-1.043,1h-0.682"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M16.451,11.569 c-0.142-0.045-0.23-0.067-0.401-0.104"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.309,7.099L6.676,7.682 c0,0-0.594,0.198-0.99,0.99l-0.99,1.716"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M12.234,10.507l-0.148-1.703 c-0.052-0.943-0.594-1.122-0.594-1.122L9.779,7.07"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.325,6.563v0.591 c0,0.396,0.33,0.462,0.726,0.462l0,0c0.396,0,0.726-0.066,0.726-0.462V6.576"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M9.304,15.061l-1.593,0.013l0,0l-6.116-0.068 v-1.782l4.751-0.128"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7.017,13.669l-1.528-1.302l-3.893-0.528 V9.925l4.883,0.726l0.627,0.502"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M9.633,11.971h2.981 c0,0,1.254,0.198,1.32,1.122c0,0,0.017,0.228,0.016,0.52"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7.342,13.72l-0.468-0.033 c-0.132,0-0.198,0.066-0.264,0.132c-0.066,0.198-0.132,0.66,0,0.99c0.066,0.132,0.198,0.132,0.264,0.132l0.574-0.164"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7.446,14.772l0.021,0.234l5.907,0.106 c0.173-0.021,0.361-0.106,0.427-0.172l0,0c0.264-0.33,0.396-0.792,0.198-1.254c-0.198-0.528-0.594-0.462-1.386-0.462l-5.147,0.132 c-0.066,0-0.132,0.132-0.132,0.198l0.014,0.151"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7.349,13.705l0.097,1.067"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M16.639,12.828 c-0.198,0.198-0.396,0.198-0.528,0.198c-0.132,0.132-0.132,0.264,0,0.33s0.264,0.066,0.33,0.066c0,0,0.108-0.019,0.206,0.019 c0.146,0.089,0.091,0.27,0.025,0.336c-0.132,0.198-0.363,0.172-0.561,0.107c-0.132-0.066-0.198-0.132-0.264-0.264 c-0.066-0.066-0.132-0.132-0.264-0.132c-0.396,0-0.726,0.066-0.99,0.066c-0.066,0-0.132,0.132-0.066,0.198 c0.264,0.33,0.99,1.056,1.979,0.924c0.132,0,0.198-0.066,0.33-0.066"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M16.837,14.61c0,0,1.518-0.396,1.32-2.045 c0,0-0.066-1.122-1.254-1.386c0,0-0.924,0.396-0.462,1.254c0,0,0.184,0.203,0.155,0.469"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M18.671,16.051L1.595,15.996v-0.99 l13.722,0.118l0.003-0.316h3.035c0.132,0,0.198,0.132,0.198,0.198v1.122"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7.787,11.015l-0.873,0.249 c-0.132,0-0.198,0.132-0.198,0.198c0,0.264,0,0.66,0.264,0.99c0.066,0.066,0.198,0.132,0.33,0.066l0.858-0.462"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.792,9.526l-2.956,0.993 c-0.132,0.066-0.132,0.132-0.132,0.264l0.528,1.452c0,0.066,0.132,0.132,0.198,0.132l0,0l3.365-1.188 c0.33-0.132,0.477-0.444,0.425-0.829"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 10.503,
    y1: 9.595,
    x2: 10.503,
    y2: 8.408
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 6.438,
    y1: 10.611,
    x2: 6.923,
    y2: 9.564
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M16.092,11.481l-0.574-0.302 c0,0-0.132-0.066-0.198,0.066l-0.132,0.462"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.858,12.103c0,0-0.325-0.333-0.193-0.597"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.605,4.835 c0.06,0.081,0.097,0.201,0.097,0.336c0,0.244-0.125,0.441-0.278,0.441c-0.003,0-0.005-0.003-0.008-0.003 C10.268,6.3,9.719,6.815,9.06,6.815c-0.659,0-1.208-0.515-1.356-1.206c-0.149-0.008-0.269-0.2-0.269-0.439 c0-0.138,0.04-0.261,0.102-0.342"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.279,5.249l0.321-0.38 c0.297-0.793-0.045-1.407-0.045-1.407c-0.478-0.957-1.708-0.82-1.708-0.82S7.821,2.778,7.48,3.598c0,0-0.472,1.108,0.399,1.519 l0.016-0.426c0,0,0.555-0.159,0.555-0.774c0,0,1.013,0.898,1.765,0.83L10.279,5.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.919,4.977L8.721,5.702 c0,0,0,0.132,0.132,0.198h0.264"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M9.315,6.296c0,0-0.33,0.132-0.528,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiotherapist);
export default __webpack_public_path__ + "static/media/physiotherapist.929bc0d363655b5a9e7c6a5bf2a16282.svg";
export { ForwardRef as ReactComponent };